import React, { useState, useEffect, useRef } from "react"
import { Grid } from '@material-ui/core';
import { Table, Card, Button } from 'antd';
import ImputComponent from "../../../../../InputComponent";
import SearchDebounceBar from '../../../../../SearchDebounce';
import { PropertySearch } from '../../../../../../factories/propertySearchs';
import { LanguageFactory } from '../../../../../../factories';
import { useLanguage } from '../../../../../../store/languageContext';
import SearchIcon from '@material-ui/icons/Search';
import ServiceModal from '../Modals/ServiceModal'

const RoomService = (props: any) => {
  const { language } = useLanguage()
  const lang = new LanguageFactory(language)
  const initialRender = useRef(true);
  const [searchs, setSearch] = useState<string[]>([]);
  const [dataSource, setDataSource] = useState<object[]>([]);
  const [total, setTotal] = useState(dataSource.length);
  const [data, setData] = useState(dataSource);
  const [visible, setVisible] = useState(false)
  const [currentRow, setCurrentRow] = useState([])

  const columns = [
    {
      title: '',
      key: 'index',
      render: (text: string, record: [], index: number) => index += 1,
      width: '40px'
  },
    {
      title: 'Service Name', 
      dataIndex: 'name', 
      key: 'name',
    },
    {
      title: 'Service Type', 
      dataIndex: 'type', 
      key: 'type',
    },
    {
      title: 'Quantity', 
      dataIndex: 'quantity', 
      key: 'quantity',
    },
    {
      title: 'Type Detail', 
      dataIndex: 'typedetail', 
      key: 'typedetail',
    },
  ]

  const onChangeSearch = (term: string) => {
      setSearchTerm(term)
      onDebounce(term)
  }
  const {
      searchTerm, setSearchTerm, searchTermDebounced, onDebounce
  } = SearchDebounceBar()

  const recentlySearchs = () => {
      return searchs.map((search, index) => {
          return (
              <span key={index} onClick={() => recoverSearch(search)}>
                  &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
              </span>
          )
      })
  }
  const recoverSearch = (search: string) => {
      setSearchTerm(search)
      filterData(search)
      onDebounce(search)
  }

  const saveNewSearch = (term: string) => {
      const stackSearchs = new PropertySearch(searchs)
      setSearch(stackSearchs.add(term))
  }
  const afterDebounce = (term: string) => {
      if (term) {
          saveNewSearch(term)
      }
      filterData(term)
  }
  const filterData = async (query: string) => {
      const filterData = data.filter((item: any) => {
          const newFilterData: any = {}
          columns.forEach((col: any) => {
              newFilterData[col['dataIndex']] = (item[col.dataIndex] == null || item[col.dataIndex] == undefined) ? '' : JSON.stringify(item[col.dataIndex]).toLowerCase();
          })
          return JSON.stringify(Object.values(newFilterData)).indexOf(query.toLowerCase()) > -1;
      })
      setDataSource(filterData);
  }
  useEffect(() => {
      const dataSourceLength = dataSource.length
      if(dataSourceLength > 0){
          // props.setDisableRoomAmenity(false)
      }
      setTotal(dataSourceLength)
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [dataSource])
  //   search functionality
  useEffect(() => {
      if (initialRender.current) {
          initialRender.current = false;
      } else {
          afterDebounce(searchTermDebounced);
      }
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [searchTermDebounced])

  useEffect(() => {
    if (Object.keys(props.currentLine.service).length > 0 && props.currentLine.service[0]?.serviceid) {
      setDataSource(props.currentLine.service)
      setData(props.currentLine.service)
    }
  }, [props.currentLine.service])

    return (
        <>
          <Card>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ fontWeight: 'bold' }}>{props.currentLine.name}</div>
              <div style={{ display: 'flex' }}>
                <div style={{margin: '0 10px 0 0'}}>
                  <Button type='primary' className='db-edit-btn' onClick={() => {props.setMeetingroomTabsActivityKey('2'); props.setCurrentOneNav('orign')}}>Back</Button>
                </div>
                <div>
                    <Button
                      type='primary' 
                      className='db-edit-btn' 
                      onClick={() => {
                        setCurrentRow([]);
                        setVisible(true);
                      }}
                    >
                      Add
                    </Button>
                </div>
              </div>
            </div>
            <Grid container spacing={0} className="containerSpacing py-0">
              <Grid item xs={4} className="pb-0 px-0 my-0">
                  <ImputComponent
                      className='SearchBar'
                      //label={lang.translate(language, 'search')}
                      label={'Search'}
                      labelShrink={true}
                      value={searchTerm}
                      onChange={onChangeSearch}
                      placeholder="Search Services"
                      endAdornment={<SearchIcon style={{ color: '#9a9a9a' }} />}
                  />
                  <div className="recentlySearchs">
                      <p>{lang.translate(language, 'recently_searched')}: {recentlySearchs()}</p>
                  </div>
              </Grid>
                <Grid item xs={12} className="p-0">
                  <Table
                      columns={columns}
                      // @ts-expect-error explanation: table error type as by defult antd is expecting an empty array
                      dataSource={dataSource}
                      onRow={record => {
                          return {
                              onClick: event => {
                                  setCurrentRow(record);
                                  setVisible(true);
                              },
                          };
                      }}
                      pagination={{
                          pageSizeOptions: ['10', '20', '50', '100'],
                          showSizeChanger: true,
                          showTotal: (total, range) => `Total ${total} items, current ${range[0]}-${range[1]}`,
                          defaultPageSize: 10,
                          defaultCurrent: 1,

                          size: "small",
                          total,

                          onChange: (page, pageSize) => {

                          }
                      }}
                  />
              </Grid>
            </Grid>
          </Card>
          <ServiceModal
            onClose={() => setVisible(false)}
            visible={visible}
            setOperation={props.setOperation}
            setCurrentRow={setCurrentRow}
            setDefKey={props.setDefKey}
            setSingleAmenity={props.setSingleAmenity}
            currentRow={currentRow}
            name={props.currentLine.name}
            data={props.currentLine}
            meetingroomsid={props.meetingroomsid}
            setDataSource={setDataSource}
            setCurrentLine={props.setCurrentLine} 
          />
        </>
    )
}

export default RoomService
